/**
 * Transform given string to a url safe slug
 * @param s string to slugify
 */
export function slugify(s: string): string {
  const a =
    'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const b =
    'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return s
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

/**
 * Transform given string to an approximation of the string pre-slug
 * @param s a slug to transform back
 */
export function deslugify(s: string): string {
  return s
    .replace('-', ' ')
    .replace(/\b[a-z]/g, (letter) => letter.toLocaleUpperCase());
}

export function addSlug<T extends {name: string}>(obj: T): T & {slug: string} {
  return {...obj, slug: slugify(obj.name)};
}
